import * as Yup from "yup"

export const folderValidationSchema = (t) =>
  Yup.object().shape({
    name: Yup.string()
      .required(t("global.name_is_required", "Name is required"))
      .max(150, t("global.name_can_only_150", "Names can be a maximum of 150 characters long.")),
    description: Yup.string().max(
      300,
      t("global.description_can_only_300", "Description can be a maximum of 300 characters long.")
    )
  })

export const attachmentValidationSchema = (t) =>
  Yup.object().shape({
    name: Yup.string()
      .required("global.name_is_required", "Name is required")
      .max(150, t("global.name_can_only_150", "Names can be a maximum of 150 characters long."))
  })

export const fileValidationSchema = (t) =>
  Yup.object().shape({
    attachments: Yup.array().of(attachmentValidationSchema(t))
  })
